enum DriverAddFormOfEmploymentType {
  B2B = "B2B",
  EMPLOYMENT = "EMPLOYMENT",
}

export default DriverAddFormOfEmploymentType;
